module.exports = __webpack_public_path__ + "static/img/p1-a-2.4180b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-a-2.png
// module id = UmzY
// module chunks = 0